export default "__VITE_ASSET__BeIBLtDX__"